import orderEdit from '../component/orderEdit.vue'
import shippingAddress from '../component/shippingAddress.vue'
export default {
  className: 'order',
  fields: [
    'orderId',
    'payTime',
    'merchants',
    'buyUser',
    {
      name: 'accountCategory',
      width: 150
    },
    {
      name: 'commodityData',
      width: 200,
      render (data) {
        let name = ''
        for (let i in data.commodityData) {
          let s = data.commodityData[i]
          name += `${s.productTitle}（价格：${s.price}，数量：${s.numberOrders}）`
          if (i < data.commodityData.length - 1) {
            name += '，'
          }
        }
        return name
      }
    },
    {
      name: 'orderAmount',
      width: 150
    },
    {
      name: 'shippingAddress',
      width: 200,
      note: '收货信息',
      view: {
        component: shippingAddress
      }
    },
    'logisticsName',
    'logisticsNumber',
    'phone',
    {
      name: 'logisticsFreight',
      note: '到付运费',
      width: 150
    },
    'leaveMessage',
    {
      name: 'status',
      width: 150,
      edit: {
        component: orderEdit
      }
    }
  ],
  search: [
    'merchants',
    'buyUser',
    'orderId'
  ],
  action: {
    create: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看订单详情',
      component: 'viewPage'
    },
    delete: {
      type: 'row',
      text: '取消',
      hidden ({ record }) {
        if (record && (record.status !== 'toBeShipped')) return true
      },
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '你确定要取消这条订单吗?')
        let rs = await vm.$modelAjax.put(modelName, record.objectId, {
          status: 'cancelled'
        }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '取消订单失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '订单已取消'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }
    }
  },
  hooks: {
    // 保存数据前判断
    async beforeSave (options) {
      // let data = options.data
      // TODO: 缺少修改订单状态的判断 暂时不做处理
    },
    // 筛选
    beforeFetch ({ where }) {
      where.status = {
        $in: ['completed', 'toBeEvaluated', 'pendingReceipt', 'toBeShipped', 'returnExchange']
      }
    }
  }
}
